import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class DepositReservationModel extends BaseModel {
  auction_uuid = null;
  amount = null;
  auction = null;
  sale_no = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    auction_uuid: '',
    amount: 'required',
  };

  attributeLabels = {
    auction_uuid: i18n.t("Sale"),
    amount: i18n.t("Amount")
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    return super.toJSON();
  }
}
